import * as React from 'react';
import styled from '@emotion/styled';

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

interface PropsType {
    className?: string;
}

export const SilkSecondaryIcon = ({ className }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        width='32'
        height='32'
        viewBox='0 0 32 32'
        fill='none'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.3334 2.66669C14 2.66669 13.0553 3.13692 12.3224 3.81552C11.5992 4.4851 11.3334 5.3107 11.3334 5.91878V7.87C11.3334 8.22921 11.6246 8.52041 11.9838 8.52041H12.3648L12.8247 8.98031C12.9466 9.10229 13.1121 9.17081 13.2846 9.17081H17.3821C17.5546 9.17081 17.7201 9.10229 17.842 8.98031L18.3019 8.52041H18.6829C19.0422 8.52041 19.3334 8.22921 19.3334 7.87V5.91878C19.3334 5.3107 19.0675 4.4851 18.3444 3.81552C17.6115 3.13692 16.6667 2.66669 15.3334 2.66669Z'
            fillOpacity='0.1'
        />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.5207 10.5211C12.7638 10.4205 13.0435 10.4761 13.2296 10.6621L14.3399 11.7724H16.4027L17.513 10.6621C17.699 10.4761 17.9788 10.4205 18.2218 10.5211C18.4648 10.6218 18.6233 10.859 18.6233 11.122V11.7724H20.5745C21.3751 11.7724 22.5176 12.0858 23.464 12.9943C24.4268 13.9186 25.1274 15.4008 25.1274 17.6261V24.7806H22V17.721C22 17.5069 21.8265 17.3334 21.6125 17.3334C21.3984 17.3334 21.2249 17.5069 21.2249 17.721L21.2249 27.057L20.9648 27.2521C20.4913 27.6072 19.6672 28.1206 18.6882 28.5475C17.7137 28.9724 16.5365 29.3334 15.3713 29.3334C14.2061 29.3334 13.0289 28.9724 12.0544 28.5475C11.0753 28.1206 10.2512 27.6072 9.77778 27.2521L9.51761 27.057L9.51761 17.7589C9.51761 17.5239 9.32713 17.3334 9.09215 17.3334C8.85717 17.3334 8.66669 17.5239 8.66669 17.7589L8.66669 24.7806H5.61517V17.6261C5.61517 15.4008 6.31577 13.9186 7.27857 12.9943C8.2249 12.0858 9.36742 11.7724 10.168 11.7724H12.1192V11.122C12.1192 10.859 12.2777 10.6218 12.5207 10.5211Z'
            fillOpacity='0.1'
        />
    </SvgElement>
);
